import { Area } from '@/shared/model/enumerations/area';

export interface IInstanciaColegiada {
  cveInstancia?: string;
  instancia?: string;
  activo?: boolean;
}

export class InstanciaColegiada implements IInstanciaColegiada {
  constructor(public cveInstancia?: string, public instancia?: string, public activo?: boolean) {}
}

export interface IGradoPrograma {
  cveGrado?: string;
  grado?: string;
  activo?: boolean;
  area?: Area;
}

export interface IModalidadPrograma {
  cveModalidad?: string;
  modalidad?: string;
  activo?: boolean;
}

export class ModalidadPrograma implements IModalidadPrograma {
  constructor(public cveModalidad?: string, public modalidad?: string, public activo?: boolean) {}
}

export interface IGradoPrograma {
  cveGrado?: string;
  grado?: string;
  activo?: boolean;
  area?: Area;
}

export class GradoPrograma implements IGradoPrograma {
  constructor(public cveGrado?: string, public grado?: string, public activo?: boolean, public area?: Area) {}
}

export interface IOrientacionPrograma {
  cveOrientacion?: string;
  orientacion?: string;
  activo?: boolean;
}

export class OrientacionPrograma implements IGradoPrograma {
  constructor(public cveOrientacion?: string, public orientacion?: string, public activo?: boolean) {}
}

export interface ICaracteristicaPrograma {
  cveCaracteristica?: string;
  caracteristica?: string;
  activo?: boolean;
}

export class CaracteristicaPrograma implements IGradoPrograma {
  constructor(public cveCaracteristica?: string, public caracteristica?: string, public activo?: boolean) {}
}

export interface ITipoPrograma {
  cveTipo?: string;
  tipo?: string;
  activo?: boolean;
}

export class TipoPrograma implements ITipoPrograma {
  constructor(public cveTipo?: string, public tipo?: string, public activo?: boolean) {}
}

export interface IProgramaForm {
  clave?: string;
  nombre: string;
  modalidad: ModalidadPrograma | null;
  grado: GradoPrograma | null;
  orientacion: OrientacionPrograma | null;
  caracteristica: CaracteristicaPrograma | null;
  tipo: TipoPrograma | null;
  fechaCreacion: string | null;
  fechaInicio: string | null;
  anteDgp: string | null;
  rvoe?: string | null;
  tipoPrograma?: TipoPrograma;
  paginaWeb?: string | null;
  tipoConvocatoria?: TipoConvocatoria | null;
  maximaInstancia?: InstanciaColegiada | null;
  fechaAprobacion?: string | null;
  numeroDeActa?: string | null;
}

export interface ITipoConvocatoria {
  cveTipoConvocatoria?: string;
  nombre?: string;
}

export class TipoConvocatoria implements ITipoConvocatoria {
  constructor(public cveTipoConvocatoria?: string, public nombre?: string) {}
}

export class ProgramaForm implements IProgramaForm {
  constructor(
    public clave?: string,
    public nombre: string = '',
    public modalidad: ModalidadPrograma | null = null,
    public grado: GradoPrograma | null = null,
    public orientacion: OrientacionPrograma | null = null,
    public caracteristica: CaracteristicaPrograma | null = null,
    public tipo: TipoPrograma | null = null,
    public fechaCreacion: string | null = null,
    public fechaInicio: string | null = null,
    public anteDgp: string | null = null,
    public rvoe?: string | null,
    public tipoPrograma?: TipoPrograma,
    public paginaWeb?: string | null,
    public tipoConvocatoria?: TipoConvocatoria | null,
    public maximaInstancia?: InstanciaColegiada | null,
    public fechaAprobacion?: string | null,
    public numeroDeActa?: string | null
  ) {}
}
